import React from "react"
import { Widgets } from "../utilities"
import IScalarForm, { SCALAR_TYPES } from "./interface/IScalarForm"
import Array from "./scalars/Array"
import Boolean from "./scalars/Boolean"
import Checkbox from "./scalars/Checkbox"
import CheckboxGroup from "./scalars/CheckboxGroup"
import Color from "./scalars/Color"
import DataTypeSelector from "./scalars/DataTypeSelector"
import DateTime from "./scalars/DateTime"
import Depth from "./scalars/Depth"
import Enum from "./scalars/Enum"
import ExternalArray from "./scalars/ExternalArray"
import ExternalSingle from "./scalars/ExternalSingle"
import ExternalTags from "./scalars/ExternalTags"
import Gallery from "./scalars/Gallery"
import Geo from "./scalars/Geo"
import HTML from "./scalars/HTML"
import Icon from "./scalars/Icon"
import ImageCheckbox from "./scalars/ImageCheckbox"
import ImageRadio from "./scalars/ImageRadio"
import Media from "./scalars/Media"
import Number from "./scalars/Number"
import Percentage from "./scalars/Percentage"
import PostStatus from "./scalars/PostStatus"
import Radio from "./scalars/Radio"
import Rutube from "./scalars/Rutube"
import Select from "./scalars/Select"
import Slider from "./scalars/Slider"
import Speedometer from "./scalars/Speedometer"
import String from "./scalars/String"
import Tags from "./scalars/Tags"
import TimeDuration from "./scalars/TimeDuration"
import URL from "./scalars/URL"
import Upload from "./scalars/Upload"
import UserSingle from "./scalars/UserSingle"
import VKVideo from "./scalars/VKVideo"
import Youtube from "./scalars/Youtube"
import YoutubeList from "./scalars/YoutubeList"
import "./style.scss"
import CSSProperties from "./scalars/CSSProperties"
import Id from "./scalars/Id"
import CSSMagnitude from "./scalars/CSSMagnitude"
import GoogleFonts from "./scalars/GoogleFonts"
import ImageRadioCarousel from "./scalars/ImageRadioCarousel"
import EditingArray from "./scalars/EditingArray"
import Border from "./scalars/Border"
import BorderRadius from "./scalars/BorderRadius"
import Options from "./scalars/Options" 
import Popover from "./scalars/Popover"
import PopoverMulti from "./scalars/PopoverMulti"

const FieldInput = (props: IScalarForm ) : React.ReactElement => {
  /* */
  if (props.visualization) {
    // console.log(props)
    // return <div className="lead p-4">( {props.title}::: {props.visualization} )  </div>
    return <Widgets 
      areaName={props.visualization}
      data={props}
      defArea={
        <div className="py-3">
          <String 
            {...props} 
            editable={false}
            className={"lead"}
            value={ props.visualization}
            onChange={props.onChange}
          /> 
        </div>
      }
    />
  } 
    
  
  switch(props.type)
  {
    case SCALAR_TYPES.POPOVER:
      return <Popover {...props} /> 
    case SCALAR_TYPES.POPOVER_MULTI:
      return <PopoverMulti {...props} /> 
    case SCALAR_TYPES.OPTIONS:
      return <Options {...props} /> 
    case SCALAR_TYPES.BORDER_RADIUS:
      return <BorderRadius {...props} /> 
    case SCALAR_TYPES.BORDER:
      return <Border {...props} /> 
    case SCALAR_TYPES.EDITING_ARRAY:
      return <EditingArray {...props} /> 
    case SCALAR_TYPES.GOOGLE_FONTS:
      return <GoogleFonts {...props} /> 
    case SCALAR_TYPES.CSS_MAGNITUDE:
      return <CSSMagnitude {...props} /> 
    case SCALAR_TYPES.CSS_PROPERTIES:
      return <CSSProperties {...props} /> 
    case SCALAR_TYPES.ENUM:
      return <Enum {...props} />
    case SCALAR_TYPES.CHECKBOX_GROUP:
      return <CheckboxGroup {...props} />
    case SCALAR_TYPES.SELECT:
      return <Select {...props} />
    case SCALAR_TYPES.ICON:
      return <Icon {...props} />
    case SCALAR_TYPES.GEO:
      return <Geo {...props} />
    case SCALAR_TYPES.SLIDER:
      return <Slider {...props} />
    case SCALAR_TYPES.UPLOAD:
      return <Upload {...props} />
    case SCALAR_TYPES.URL:
      return <URL {...props} />
    case SCALAR_TYPES.COLOR:
      return <Color {...props} />
    case SCALAR_TYPES.EXTERNAL:
      return <ExternalSingle {...props} />
    case SCALAR_TYPES.USER:
      return <UserSingle {...props} />
    case SCALAR_TYPES.EXTERNAL_ARRAY:
      return <ExternalArray {...props} />
    case SCALAR_TYPES.EXTERNAL_TAGS:
      return <ExternalTags {...props} />
    case SCALAR_TYPES.YOUTUBE_ID:
      return <Youtube {...props} />
    case SCALAR_TYPES.VK_VIDEO_ID:
      return <VKVideo {...props} />
    case SCALAR_TYPES.RUTUBE_ID:
      return <Rutube {...props} />
    case SCALAR_TYPES.YOUTUBE_LIST:
      return <YoutubeList {...props} />
    case SCALAR_TYPES.NUMBER:
      return <Number {...props} />
    case SCALAR_TYPES.BOOLEAN:
      return <Boolean {...props} />
    case SCALAR_TYPES.CHECKBOX:
      return <Checkbox {...props} />
    case SCALAR_TYPES.IMAGE_CHECKBOX:
      return <ImageCheckbox {...props} />
    case SCALAR_TYPES.RADIO:
      return <Radio {...props} />
    case SCALAR_TYPES.IMAGE_RADIO:
      return <ImageRadio {...props} /> 
    case SCALAR_TYPES.IMAGE_RADIO_CAROUSEL:
      return <ImageRadioCarousel {...props} /> 
    case SCALAR_TYPES.TAGS:
      return <Tags {...props} />
    case SCALAR_TYPES.DATE:
      return <DateTime {...props} />
    case SCALAR_TYPES.HTML:
    case SCALAR_TYPES.TEXT: 
      return <HTML {...props} />
    case SCALAR_TYPES.MEDIA:
      return <Media {...props} />
    case SCALAR_TYPES.GALLERY:
      return <Gallery {...props} />
    case SCALAR_TYPES.POST_STATUS:
      return <PostStatus {...props} />
    case SCALAR_TYPES.TIME_DURATION:
      return <TimeDuration {...props} />
    case SCALAR_TYPES.SPEEDOMETER:
      return <Speedometer {...props} />
    case SCALAR_TYPES.PERCENTAGE:
      return <Percentage {...props} />
    case SCALAR_TYPES.DEPTH:
      return <Depth {...props} />
    case SCALAR_TYPES.ARRAY:
      return <Array {...props} />
    case SCALAR_TYPES.DATA_TYPE:
      return <DataTypeSelector {...props} />
    case SCALAR_TYPES.ID:
      return <Id {...props} />
    case SCALAR_TYPES.STRING:
    default:
      return <String {...props} />
  }
} 
export default FieldInput 
export { SCALAR_TYPES }
